"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DisabledCameraBody = require("./DisabledCameraBody.styled");
var DisabledCameraBody = function DisabledCameraBody(_ref) {
  var isUnassigned = _ref.isUnassigned;
  return /*#__PURE__*/_react["default"].createElement(_DisabledCameraBody.DisabledCameraBackground, {
    isUnassigned: isUnassigned
  }, /*#__PURE__*/_react["default"].createElement(_DisabledCameraBody.DisabledIconBackground, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faVideoSlash
  })), /*#__PURE__*/_react["default"].createElement(_DisabledCameraBody.DisabledCameraText, null, "Camera off"));
};
DisabledCameraBody.propTypes = {
  isUnassigned: _propTypes["default"].bool
};
var _default = exports["default"] = DisabledCameraBody;